import * as actionTypes from '../utils/constants';

const initialState = {};
const derwentBuildingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_DERWENT_BUIDLINGS: {
      const newState = {
        ...state,
      };
      newState.derwentBuildingsReducer = action.action;
      return newState;
    }
    case actionTypes.GET_DERWENT_VILLAGE_BUIDLINGS: {
      const newState = {
        ...state,
      };
      newState.derwentVillageBuildings = action.action;
      return newState;
    }
    default: {
      return state;
    }
  }
};

export default derwentBuildingsReducer;
